import { insecureAPI } from './API';

async function sentContact(payload) {
    return new Promise((resolve, reject) => {
        insecureAPI()
        .post('/public/contact', payload)
        .then(({ data }) => {
            if (data.success) {
                resolve(data.data); //return array
            }
        })
        .catch((err) => {
			reject(err?.response?.data?.error);
		});
    });
}
async function sentApplication(payload) {
    return new Promise((resolve, reject) => {
        insecureAPI()
        .post('/public/application', payload)
        .then(({ data }) => {
            if (data.success) {
                resolve(data.data); //return array
            }
        })
        .catch((err) => {
			reject(err?.response?.data?.error);
		});
    });
}
async function recaptchaValidate(token){
    
    return new Promise((resolve, reject) => {
        insecureAPI()
        .post(`/public/recaptchavalidate/${token}`, {})
        .then(({ data }) => {
            if (data.success) {
                resolve(data); //return array
            }
        })
        .catch((err) => {
			reject(err?.response?.data?.error);
		});
    });
}
async function getAllService() {
    return new Promise((resolve, reject) => {
        insecureAPI()
        .get('/public/getservice')
        .then(({ data }) => {
            if (data.success) {
                resolve(data.data); //return array
            }
        })
        .catch((err) => {
			reject(err?.response?.data?.error);
		});
    });
}
// News letter submit
async function newsLetter(payload) {
    return new Promise((resolve, reject) => {
        insecureAPI()
        .post('/public/newsletter', payload)
        .then(({ data }) => {
            if (data.success) {
                resolve(data.data); //return array
            }
        })
        .catch((err) => {
			reject(err?.response?.data?.error);
		});
    });
}
export { sentContact, sentApplication, recaptchaValidate, getAllService, newsLetter };
